import * as _ from 'lodash';

import { Module } from '../../ts/Module';
import { BaseReactSettingsCtrl, BaseReactSettingsCtrlScope } from '../controllers/BaseReactSettingsCtrl';
import { IServerSettingsFormScope } from '../controllers/ServerSettingsFormCtrl';
import { SectionContainerBaseProps } from '../general-settings/components/GeneralSettingsPageBase';
import { ServerSettingsProps } from '../general-settings/components/ReactServerSettings';
import { OuterSiteSettingsForSiteAdminProps, SiteSettingsForSiteAdminProps } from '../general-settings/components/ReactSiteSettingsForSiteAdmin';
import { SettingsFormService } from './tbSettingsCoordinator';

class ReactServerSettingsCtrl extends BaseReactSettingsCtrl<OuterSiteSettingsForSiteAdminProps>{
  private static formName: string = 'ReactServerSettingsForm';
  private static instanceCount = 0;

  public static $inject = [
    '$scope',
    'SettingsFormService',
  ];

  constructor(
    protected $scope: BaseReactSettingsCtrlScope<any> & SectionContainerBaseProps,
    formService: SettingsFormService
  ) {
    super($scope, formService, ReactServerSettingsCtrl.formName + ReactServerSettingsCtrl.instanceCount++);
  }

  $onInit() {
    // This directive uses an isolated scope to bind the value of sections and allow multiple copies of it to be created
    // use the parent scope to access values defined in the parent controller
    const $parent = this.$scope.$parent as IServerSettingsFormScope;
    this.$scope.props = {
      ...this.$scope.props,
      settings: {...this.$scope.settings},
      sections: this.$scope.sections,
      serverTimestamps: $parent.serverTimestamps,

      // copy changed values to the parent scope and trigger a digest
      mergeIntoParentScope: (values: ServerSettingsProps) => {
        $parent.serverSettingsOptions = values.settings;
        this.$scope.$applyAsync();
      }
    };

    // watch changes to the settings to rerender the react component if they change. This is used to provide updated
    // values of the non-migrated settings
    $parent.$on('serverSettingsOptions.change', (event: any, newValue: any) => {
      this.$scope.props = {
        ...this.$scope.props,
        settings: newValue
      };
    });
  }
}

/**
 * An adapter to create named settings sections in angular pug files. This simplifies adding new settings using react
 * without worrying about the details of adapting it to angularjs.
 *
 * Usage: just add the directive in serverSettingsForm.pug as follows:
 * tb:server-settings-form-adapter(sections="['section1', 'section2', ...]")
 *
 * where section1, section2 are the names of the actual sections to render in the adapter.
 *
 * This adapter can render multiple sections, so if there is an existing adapter in the area you want to add your section
 * you can append your section name to the array without having to add a new adapter.
 */
Module.instance().directive('tbServerSettingsFormAdapter', () => {
  return {
    restrict: 'E',
    require: ['^?tbSettingsCoordinator', '^tbServerSettingsForm'],
    template: '<tb:react-server-settings props="props"/>',
    controller: ReactServerSettingsCtrl,
    scope: {
      sections: '<',
      settings: '<'
    }
  };
});
